import { useEffect, useState } from 'react';
import Switch from '@material-ui/core/Switch';
import { makeStyles, Grid, Box, Dialog, Divider, withStyles, Button, Theme, createStyles, TextField } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { createRole, updateRole } from "../../../../store/actions/admin/role";
import { useDispatch, useSelector } from "react-redux";

const styles = (theme: Theme) =>
	createStyles({
		root: {
			margin: 0,
			padding: theme.spacing(2),
			paddingTop: 26
		},
		closeButton: {
			position: 'absolute',
			right: theme.spacing(1),
			background: 'transparent!important'
		},
		header: {
			color: '#212D40',
			fontFamily: 'Spartan-bold',
			fontSize: 24,
			paddingLeft: 17,
			paddingBottom: 7,
			display: 'flex',
			alignItems: 'center'
		}
	});

const useStyles = makeStyles(() => ({
	root: {},
	paper: {
		borderRadius: '24px!important'
	},
	createBtn: {
		width: 91,
		height: 37,
		borderRadius: 6,
		background: '#0179EE',
		color: '#FFFFFF',
		textTransform: 'none',
		fontSize: 14,
		fontFamily: 'roboto-regular',
		'&:hover': {
			background: '#0f9fef'
		},
	},
	cancelBtn: {
		width: 91,
		height: 37,
		borderRadius: 6,
		background: '#F0F0F0',
		color: '#697683',
		textTransform: 'none',
		fontSize: 14,
		fontFamily: 'roboto-regular',
		'&:hover': {
			background: '#e0e0e0',
		},
	}
}));

const RoleModel = ({ open, onClose, from }: any) => {

	const classes = useStyles();
	const dispatch = useDispatch();
	const apolloClient = useSelector((state: any) => state.apolloClient);
	const { roleDetails } = useSelector((state: any) => state.adminRole);
	const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
	const [actionStatus, setActionStatus] = useState(0);
	const [state, setState] = useState({
		roleName: "",
		roleAlias: "",
		roleDesc: "",
	});
	const [accessPages, setAccessPages] = useState({
		home_page: false,
		my_profile: true,
		admin_roles: false,
		admin_users: false,
		test_page: false,
		participant_dashboard: false,
		participant_async: false,
		participant_mod: false,
		creator_dashboard: false,
		creator_onboarding: false,
		experience_builder: false,
		experience_manager: false,
		experience_live: false,
		experience_analysis: false,
		trial_onboarding:false,
		trial_dashboard:false,
		trial_builder:false,
		trial_experiences:false,
		trial_profile:false,
		trial_admin:false
	})

	//set all data when open edit role popup
	useEffect(() => {
		if (from === "edit" && roleDetails !== undefined && roleDetails.accesspages !== undefined) {
			setActionStatus(1);
			setState({
				roleName: roleDetails.role_name,
				roleAlias: roleDetails.role_alias,
				roleDesc: roleDetails.role_desc,
			});
			setAccessPages(
				roleDetails.accesspages
			)
		}
	}, [roleDetails, from]);


	//Method call on create role button
	const onAddRole = () => {
		if (validateRoleName(state.roleName)) {
			const request = {
				rolename: state.roleName,
				rolealias: state.roleAlias,
				roledesc: state.roleDesc,
				accesspages: accessPages,
				schema: loginUserData.customer_name
			};
			dispatch(createRole(apolloClient.client, request));
			onClose()
		}
	};

	//Method call on update role button
	const onUpdateRole = () => {
		if (validateRoleName(state.roleName)) {
			const request = {
				roleid: roleDetails.role_id,
				rolename: state.roleName,
				rolealias: state.roleAlias,
				roledesc: state.roleDesc,
				accesspages: accessPages,
				schema: loginUserData.customer_name
			};
			dispatch(updateRole(apolloClient.client, request));
			onClose()
		}
	};

	// Call method on input change
	const handleChange = (e: any) => {
		const { name, value } = e.target;
		setState(prevState => ({
			...prevState,
			[name]: value
		}));
	};

	// Call method on switch change
	const handleSwitch = (e: any, checked: any) => {
		const { name } = e.target;
		setAccessPages(prevState => ({
			...prevState,
			[name]: checked
		}));
	};

	// Check role name
	const validateRoleName = (name: string) => {
		return name?.length > 1
	};

	const DialogTitle = withStyles(styles)((props: any) => {
		const { children, classes, onClose, ...other } = props;
		return (
			<MuiDialogTitle disableTypography className={classes.root} {...other}>
				<div className={classes.header}>
					{children}
					{onClose ? (
						<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
							<img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
						</IconButton>
					) : null}
				</div>
			</MuiDialogTitle>
		);
	});

	return (
		<div>
			<Grid container>
				<Grid item>
					<Dialog
						
						disableEscapeKeyDown
						fullWidth={true}
						maxWidth={'sm'}
						open={open}
						className="modal-custom"
						scroll="body"
					>
						<div>
							<DialogTitle onClose={onClose}>
								{actionStatus ? "Update " : "Create "}
								 a role
        					</DialogTitle>
							<Divider />

							<Box m={4} pl={1} mt={0} pr={1}>
								<TextField
									value={state.roleName}
									fullWidth
									margin="normal"
									id="roleName"
									label="Role Name"
									name="roleName"
									onChange={(e) => handleChange(e)}
								/>
								<TextField
									value={state.roleAlias}
									fullWidth
									margin="normal"
									id="roleAlias"
									label="Role Alias"
									name="roleAlias"
									onChange={(e) => handleChange(e)}
								/>
								<TextField
									value={state.roleDesc}
									fullWidth
									margin="normal"
									id="roleDesc"
									label="Role Description"
									name="roleDesc"
									onChange={(e) => handleChange(e)}
								/>
								<Grid container spacing={3} className="role-create">
									<Grid item xs={6}>
										<Grid container spacing={1}>
											<Grid item xs={12}>
												<label>Home</label>
												<Switch
													checked={accessPages.home_page ? accessPages.home_page : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="home_page"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Admin Roles</label>
												<Switch
													checked={accessPages.admin_roles ? accessPages.admin_roles : false}
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													className="access-page-switch"
													color="primary"
													name="admin_roles"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Participant dashboard</label>
												<Switch
													checked={accessPages.participant_dashboard ? accessPages.participant_dashboard : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="participant_dashboard"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Participant mod</label>
												<Switch
													checked={accessPages.participant_mod ? accessPages.participant_mod : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="participant_mod"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Create onboarding</label>
												<Switch
													checked={accessPages.creator_onboarding ? accessPages.creator_onboarding : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="creator_onboarding"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience manager</label>
												<Switch
													checked={accessPages.experience_manager ? accessPages.experience_manager : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="experience_manager"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience analysis</label>
												<Switch
													checked={accessPages.experience_analysis ? accessPages.experience_analysis : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="experience_analysis"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial dashboard</label>
												<Switch
													checked={accessPages.trial_dashboard ? accessPages.trial_dashboard : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="trial_dashboard"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial experiences</label>
												<Switch
													checked={accessPages.trial_experiences ? accessPages.trial_experiences : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="trial_experiences"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial admin</label>
												<Switch
													checked={accessPages.trial_admin ? accessPages.trial_admin : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="trial_admin"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
										</Grid>
									</Grid>
									<Grid item xs={6}>
										<Grid container spacing={1}>
											<Grid item xs={12}>
												<label>User profile</label>
												<Switch
													disabled={true}
													checked={accessPages.my_profile ? accessPages.my_profile : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="my_profile"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Admin Users</label>
												<Switch
													checked={accessPages.admin_users ? accessPages.admin_users : false}
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													className="access-page-switch"
													color="primary"
													name="admin_users"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Participant async</label>
												<Switch
													checked={accessPages.participant_async ? accessPages.participant_async : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="participant_async"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Creator dashboard</label>
												<Switch
													checked={accessPages.creator_dashboard ? accessPages.creator_dashboard : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="creator_dashboard"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience builder</label>
												<Switch
													checked={accessPages.experience_builder ? accessPages.experience_builder : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="experience_builder"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience live</label>
												<Switch
													checked={accessPages.experience_live ? accessPages.experience_live : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="experience_live"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial onboarding</label>
												<Switch
													checked={accessPages.trial_onboarding ? accessPages.trial_onboarding : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="trial_onboarding"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial builder</label>
												<Switch
													checked={accessPages.trial_builder ? accessPages.trial_builder : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="trial_builder"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial profile</label>
												<Switch
													checked={accessPages.trial_profile ? accessPages.trial_profile : false}
													className="access-page-switch"
													onChange={(checked, event) =>
														handleSwitch(checked, event)
													}
													color="primary"
													name="trial_profile"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
										</Grid>
									</Grid>
								</Grid>

							</Box>
							<Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
								<Button onClick={onClose}>
									Cancel
								</Button>&nbsp;&nbsp;&nbsp;
								{actionStatus ?
									<Button
										onClick={() => onUpdateRole()}
										disabled={!validateRoleName(state.roleName)}
										style={!validateRoleName(state.roleName) ? { backgroundColor: "#F0F0F0" } : {}}
										className={classes.createBtn}
									>
										Update
									</Button> :
									<Button
										onClick={() => onAddRole()}
										disabled={!validateRoleName(state.roleName)}
										style={!validateRoleName(state.roleName) ? { backgroundColor: "#F0F0F0" } : {}}
										className={classes.createBtn}
									>
										Create
								</Button>}
							</Box>
						</div>
					</Dialog>
				</Grid>
			</Grid>
		</div>
	)
};

export default RoleModel;

